import { CampaignType } from '../typings/domain';
import {
    WelcomeBannerParams,
    WelcomeBannerType,
    WelcomeScreenData
} from '../typings/welcome';

export const CHANGE_WELCOME_PAGE_DATA = 'CHANGE_WELCOME_PAGE_DATA';
export type CHANGE_WELCOME_PAGE_DATA = typeof CHANGE_WELCOME_PAGE_DATA;

export const SUBMIT_BASE_USER_SETTINGS = 'SUBMIT_BASE_USER_SETTINGS';
export type SUBMIT_BASE_USER_SETTINGS = typeof SUBMIT_BASE_USER_SETTINGS;

export const BASE_USER_SETTINGS_SUBMITTED = 'BASE_USER_SETTINGS_SUBMITTED';
export type BASE_USER_SETTINGS_SUBMITTED = typeof BASE_USER_SETTINGS_SUBMITTED;

export const BASE_USER_SETTINGS_SUBMITTED_METRIKA =
    'BASE_USER_SETTINGS_SUBMITTED_METRIKA';
export type BASE_USER_SETTINGS_SUBMITTED_METRIKA = typeof BASE_USER_SETTINGS_SUBMITTED_METRIKA;

export const CREATE_FIRST_CAMPAIGN = 'CREATE_FIRST_CAMPAIGN';
export type CREATE_FIRST_CAMPAIGN = typeof CREATE_FIRST_CAMPAIGN;

export const WELCOME_BANNER_IS_SHOWN = 'WELCOME_BANNER_IS_SHOWN';
export type WELCOME_BANNER_IS_SHOWN = typeof WELCOME_BANNER_IS_SHOWN;

export const WELCOME_BANNER_IS_CLICKED = 'WELCOME_BANNER_IS_CLICKED';
export type WELCOME_BANNER_IS_CLICKED = typeof WELCOME_BANNER_IS_CLICKED;

export interface ChangeWelcomePageData {
    type: CHANGE_WELCOME_PAGE_DATA;
    value: WelcomeScreenData;
}

export interface SubmitBaseUserSettings {
    type: SUBMIT_BASE_USER_SETTINGS;
    retpath?: string;
}

export interface BaseUserSettingsSubmitted {
    type: BASE_USER_SETTINGS_SUBMITTED;
    success: boolean;
    welcomeBanner?: WelcomeBannerParams;
}

export interface BaseUserSettingsSubmittedMetrikaAction {
    type: BASE_USER_SETTINGS_SUBMITTED_METRIKA;
    welcomeBanner: WelcomeBannerParams;
}

export interface CreateFirstCampaignAction {
    type: CREATE_FIRST_CAMPAIGN;
    campType: CampaignType;
}

export interface WelcomeBannerIsShownAction {
    type: WELCOME_BANNER_IS_SHOWN;
    bannerType: WelcomeBannerType;
}

export interface WelcomeBannerIsClickedAction {
    type: WELCOME_BANNER_IS_CLICKED;
    bannerType: WelcomeBannerType;
}

export function changeWelcomePageData(
    value: WelcomeScreenData
): ChangeWelcomePageData {
    return {
        type: CHANGE_WELCOME_PAGE_DATA,
        value
    };
}

export function submitBaseUserSettings(
    retpath?: string
): SubmitBaseUserSettings {
    return {
        type: SUBMIT_BASE_USER_SETTINGS,
        retpath
    };
}

export function baseUserSettingsSubmitted(
    success: boolean,
    welcomeBanner?: WelcomeBannerParams
): BaseUserSettingsSubmitted {
    return {
        type: BASE_USER_SETTINGS_SUBMITTED,
        success,
        welcomeBanner
    };
}

export function baseUserSettingsSubmittedMetrika(
    welcomeBanner: WelcomeBannerParams
): BaseUserSettingsSubmittedMetrikaAction {
    return {
        type: BASE_USER_SETTINGS_SUBMITTED_METRIKA,
        welcomeBanner
    };
}

export function createFirstCampaign(
    campType: CampaignType
): CreateFirstCampaignAction {
    return {
        type: CREATE_FIRST_CAMPAIGN,
        campType
    };
}

export function welcomeBannerIsShown(
    bannerType: WelcomeBannerType
): WelcomeBannerIsShownAction {
    return {
        type: WELCOME_BANNER_IS_SHOWN,
        bannerType
    };
}

export function welcomeBannerIsClicked(
    bannerType: WelcomeBannerType
): WelcomeBannerIsClickedAction {
    return {
        type: WELCOME_BANNER_IS_CLICKED,
        bannerType
    };
}

export type WelcomeScreenAction =
    | WelcomeBannerIsShownAction
    | WelcomeBannerIsClickedAction
    | CreateFirstCampaignAction
    | ChangeWelcomePageData
    | SubmitBaseUserSettings
    | BaseUserSettingsSubmitted
    | BaseUserSettingsSubmittedMetrikaAction;
